/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { UomListTypes } from './Actions';
import INITIAL_STATE from './InitialState';

export const uomListResetTimestamp = (state, { currentPage, sorts, filters, pageSize }) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now(),
  // selectedDocuments: INITIAL_STATE.selectedDocuments,
  toStorageBinOptions: INITIAL_STATE.toStorageBinOptions,
  toStorageBinOption: INITIAL_STATE.toStorageBinOption
});

export const uomListFetchListLoading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const uomListFetchListSuccess = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const uomListAddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const uomListRemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const uomListSetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [UomListTypes.UOM_LIST_RESET_TIMESTAMP]: uomListResetTimestamp,
  [UomListTypes.UOM_LIST_FETCH_LIST_LOADING]: uomListFetchListLoading,
  [UomListTypes.UOM_LIST_FETCH_LIST_SUCCESS]: uomListFetchListSuccess,
  [UomListTypes.UOM_LIST_ADD_SELECTED_DOCUMENTS]: uomListAddSelectedDocuments,
  [UomListTypes.UOM_LIST_REMOVE_SELECTED_DOCUMENTS]: uomListRemoveSelectedDocuments,
  [UomListTypes.UOM_LIST_SET_WORKSPACE_VISIBLE]: uomListSetWorkspaceVisible
});
